import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import "react-toastify/dist/ReactToastify.css";
import { CustomAutocomplete } from "./AutoComplete";

export const Level3AutoComplete = ({ value, onChange }) => {
  const level3 = useSelector((state) => state.accountLevels.level3);
  console.log(level3);
  const [level3Array, setLevel3Array] = React.useState([]);
  useEffect(() => {
    let arr = [...level3];
    arr = arr.map((item) => {
      return {
        ...item,
        name: item.Discription ? item.Discription : item.name,
      };
    });
    setLevel3Array([...arr.filter((item) => item.type ==="Supplier" || item.type ==="EXPENSES")]);
  }, [level3]);
  return (
    <CustomAutocomplete
      options={level3Array}
      getOptionLabel={(option) =>
        option.fullcode +
        "\t" +
        "" +
        "\t" +
        option.name 
      }
      defaultValue={level3Array[0]}
      value={value}
      onChange={onChange}
      label="Select Header for payment"
    />
  );
};
{
  /* <Autocomplete
          key={l3Update}
          onBlurCapture={handleCodeLevel3}
          disablePortal
          id="combo-box-code"
          getOptionLabel={option =>
            option.fullcode + '\t' + '' + '\t' + option.name
          }
          options={level3Codes}
          renderInput={params => (
            <TextField
              {...params}
              style={{ width: '300px' }}
              label="Level Three Code"
            />
          )}
        /> */
}
